import React, { useState, useEffect } from 'react';

const useMultiSelect = (itemsList: any[]) => {
  const [selectedItems, setSelect] = useState([] as any);

  // De-select all items if the length of the entries changed
  useEffect(() => {
    setSelect([]);
  }, [itemsList.length]);

  /**
   * Select/De-select single item based on the checked flag
   * @param item
   */
  const selectItem = (item: any) => ({
    target: { checked },
  }: React.ChangeEvent<HTMLInputElement>) => {
    if (checked) {
      setSelect([...selectedItems, item]);
    } else {
      let filteredItems = [];

      filteredItems = selectedItems.filter(
        (i: any) =>
          i.productId !== item.productId ||
          (i.offerId && item.offerId && i.offerId !== item.offerId)
      );
      // {
      //   if (i.productId !== item.productId) {
      //     return i;
      //   }
      //   if (i.offerId && item.offerId && i.offerId !== item.offerId ){
      //     return i;
      //   }
      //   return
      // });

      setSelect([...filteredItems]);
    }
  };

  const toggleAllItems = (flag: boolean) => {
    if (flag) {
      setSelect([...itemsList]);
    } else {
      setSelect([]);
    }
  };

  /**
   * Select/De-select all items based on the passed parameter (event or boolean)
   */
  function selectAll(checked: boolean): void;
  function selectAll(event: React.ChangeEvent<HTMLInputElement>): void;
  function selectAll(state: boolean | React.ChangeEvent<HTMLInputElement>): void {
    if (typeof state === 'boolean') {
      toggleAllItems(state);
    } else {
      toggleAllItems(state.target.checked);
    }
  }

  const isSelected = (item: any) => {
    const hasList = selectedItems.filter(
      (i: any) =>
        i.productId === item.productId && (item.offerId === null || item.offerId === i.offerId)
    );
    if (hasList.length) {
      return true;
    }
    return false;
  };

  return [selectedItems, { selectItem, selectAll, isSelected }];
};

export default useMultiSelect;
